// extracted by mini-css-extract-plugin
export var colorSquare = "_rt-0";
export var danger = "_rt-5";
export var lightPink = "_rt-8";
export var neutralBlue = "_rt-7";
export var neutralYellow = "_rt-6";
export var normal = "_rt-1";
export var primary = "_rt-2";
export var primaryLight = "_rt-3";
export var solidBlack = "_rt-g";
export var solidGreen = "_rt-b";
export var solidLightBlue = "_rt-d";
export var solidNavy = "_rt-c";
export var solidOrange = "_rt-f";
export var solidPink = "_rt-e";
export var solidRed = "_rt-9";
export var solidYellow = "_rt-a";
export var success = "_rt-4";